export default __webpack_public_path__ + "static/preschool3-7154bb3931b91a879e1854def2bcc1c5.jpg";